"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_css_grid_1 = require("styled-css-grid");
var styled_components_1 = __importDefault(require("styled-components"));
var _DayLabelCell = styled_components_1.default(styled_css_grid_1.Cell)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  // border: 1px solid #999;\n  // background: #feedde;\n  line-height: 1;\n  font-variant: all-small-caps;\n"], ["\n  font-size: 12px;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  // border: 1px solid #999;\n  // background: #feedde;\n  line-height: 1;\n  font-variant: all-small-caps;\n"])));
var DayLabelCell = function (props) {
    return (react_1.default.createElement(_DayLabelCell, __assign({ center: true, middle: true }, props)));
};
exports.default = DayLabelCell;
var templateObject_1;
